module.exports = __webpack_public_path__ + "static/media/header.d9e3f745.jpg";